import Input from "./Input/Input";
import Select from "./Select/Select";
import TextArea from "./TextArea/TextArea";
import DateTime from "./DateTime/DateTime";
import Slider from "./Sider/Slider";
import Password from "./Password/Password";
import SubHeader from "./SubHeader/SubHeader";
import Text from "./Text/Text";
import RadioGroup from "./RadioGroup/RadioGroup";
import FileUpload from "./FileUpload/FileUpload";
import CheckBoxList from "./CheckBoxList/CheckBoxList";
import CheckBox from "./CheckBoxList/CheckBox/CheckBox";
const FormType = {
  Input,
  Select,
  TextArea,
  DateTime,
  Slider,
  Password,
  SubHeader,
  Text,
  RadioGroup,
  FileUpload,
  CheckBoxList,
  CheckBox
};

export default FormType;
